export function scheduleTask(task = () => {}, ms = 10) {
  setTimeout(task, ms);
}
